import { useMutation } from '@tanstack/react-query';
import { rebuildProject } from 'enteties/project/api';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { useCallback, useMemo } from 'react';
import { LoadingButton } from 'shared/ui/loading-button';
import { useIsProjectControlButtonDisabled } from '@/enteties/project/hooks/useIsProjectControlButtonDisabled';
import type { ProjectControlProps } from 'widgets/instance-controller/ui/instance-controller';
import type { ButtonProps } from 'shared/ui/button';
import * as m from '@paraglide/messages';
export interface ProjectControlPropsWithTimeout extends ProjectControlProps, ButtonProps {
  isTimedOut?: boolean;
  setIsTimedOut?: Dispatch<SetStateAction<boolean>>;
  buttonChild: string | ReactNode;
}
interface BuildProjectProps extends ProjectControlPropsWithTimeout {
  notDisabled?: boolean;
}
export const BuildProject = ({
  slug,
  project,
  isTimedOut,
  setIsTimedOut,
  buttonChild,
  notDisabled = false,
  ...props
}: BuildProjectProps) => {
  const {
    mutate,
    isPending
  } = useMutation({
    mutationFn: () => rebuildProject(slug),
    onSuccess: () => {
      if (setIsTimedOut) {
        setTimeout(() => setIsTimedOut(false), 15_000);
      }
    }
  });
  const isDefaultDisabled = useIsProjectControlButtonDisabled(project, slug, true);
  const isDisabled = useMemo(() => isTimedOut || isDefaultDisabled, [isDefaultDisabled, isTimedOut]);
  const handleOnClick = useCallback(() => {
    if (setIsTimedOut) {
      setIsTimedOut(true);
    }
    mutate();
  }, [mutate]);
  return <LoadingButton loading={isPending} disabled={notDisabled ? false : isDisabled} onClick={handleOnClick} loaderSize="w-5 h-5" toolTipContent={`${m.project_ctrl_btns_rebuild()} ${m.project_ctrl_btns_project()}`} {...props} data-sentry-element="LoadingButton" data-sentry-component="BuildProject" data-sentry-source-file="build-project.tsx">
      {buttonChild}
    </LoadingButton>;
};